module.exports = __webpack_public_path__ + "static/img/youxiaClick.25d0301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/youxiaClick.png
// module id = 2plq
// module chunks = 0